// Resolve geometry before appending a page to masonry. Late portrait posters must not
// turn already visible landscape cards sideways and push everything below them around.
const assets = new Map();
export function preparePoster(src) {
  if (!src) return Promise.resolve({});
  if (assets.has(src)) return assets.get(src);
  const promise = new Promise(resolve => {
    const img = new Image();
    let done = false;
    const finish = result => {
      if (done) return; done = true; clearTimeout(timer);
      img.onload = null; img.onerror = null; resolve(result);
    };
    const timer = setTimeout(() => finish({ posterUnavailable: true }), 4000);
    img.referrerPolicy = 'no-referrer';
    img.onload = () => finish({ posterAspectRatio: img.naturalWidth / img.naturalHeight });
    img.onerror = () => finish({ posterUnavailable: true });
    img.src = src;
  });
  assets.set(src, promise);
  if (assets.size > 256) assets.delete(assets.keys().next().value);
  return promise;
}
export async function prepareEventPosters(events) {
  // The card shows the host's grid-card photo when one is picked, so that is the shape to measure.
  return Promise.all(events.map(async event => ({ ...event, ...await preparePoster(event.cardImageUrl || event.posterUrl) })));
}
